import Raven from 'raven-js';
import HsfxReminderBanner from 'setup-guide-components/components/banner/HsfxReminderBanner';
import { useEffect, useState } from 'react';
import { useTracker } from 'setup-guide-components/hooks/tracking';
import { useIsFreePortal } from 'onboarding-scopes';
import { fetchDiscount, shouldShowBanner } from '../../utils/hsfxReminderUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const HsfxBannerContainer = () => {
  const {
    trackSectionView
  } = useTracker();
  const freePortal = useIsFreePortal();
  const [reminderState, setReminderState] = useState({
    bannerActive: false,
    discount: null
  });
  const {
    bannerActive,
    discount
  } = reminderState;
  const canShowBanner = freePortal && shouldShowBanner();
  useEffect(() => {
    if (!canShowBanner) {
      setReminderState({
        bannerActive: false,
        discount: null
      });
      return;
    }
    fetchDiscount().then(discountVal => {
      if (discountVal && canShowBanner) {
        setReminderState({
          bannerActive: !!discountVal,
          discount: discountVal || null
        });
        trackSectionView('show the HSFX discount', 'HsfxBannerContainer');
      } else {
        setReminderState({
          bannerActive: false,
          discount: null
        });
      }
    }).catch(e => {
      setReminderState({
        bannerActive: false,
        discount: null
      });
      Raven.captureException(e);
    });
  }, [canShowBanner, trackSectionView]);
  if (!bannerActive) return null;
  return /*#__PURE__*/_jsx(HsfxReminderBanner, {
    discount: discount
  });
};